import { ISagaModule } from 'redux-dynamic-modules-saga';
import reducer from './reducer';
import saga from './saga';

export default function getModule(): ISagaModule<any> {
  return {
    id: 'socialLoginModule',
    reducerMap: reducer,
    sagas: [saga],
  };
}
